import { httpsCallable, type HttpsCallable } from "firebase/functions";
import * as Sentry from "@sentry/react";
import { getFirebaseClient } from "./firebase";

export function callable<TReq = unknown, TRes = unknown>(
  name: string,
): HttpsCallable<TReq, TRes> {
  const { functions } = getFirebaseClient();
  return httpsCallable<TReq, TRes>(functions, name);
}

export async function callFn<TReq = unknown, TRes = unknown>(
  name: string,
  data: TReq,
): Promise<TRes> {
  Sentry.addBreadcrumb({ category: "callable", message: name, level: "info" });
  try {
    const fn = callable<TReq, TRes>(name);
    const result = await fn(data);
    return result.data;
  } catch (err) {
    Sentry.captureException(err, { extra: { callable: name } });
    throw err;
  }
}
